<script setup lang="ts">
import { ButtonLink } from "@/components/ui"
import { useTranslation } from "@/composables"

defineProps<{
  headline?: string
  content?: string
  buttonLabel?: string
  href?: string
  to?: string
  hideButton?: boolean
}>()

const emit = defineEmits<{
  (e: "click"): void
}>()

const { t } = useTranslation()
</script>

<template>
  <div class="py-8 md:py-16 flex flex-col justify-center items-center">
    <slot name="headline">
      <h3 class="font-comfortaa font-bold text-xl mb-3" data-test="no-data-headline">
        {{ headline ?? t("no_data.headline") }}
      </h3>
    </slot>
    <slot name="content">
      <p class="font-montserrat mb-5 max-w-xl text-center" data-test="no-data-content">
        {{ content ?? t("no_data.content") }}
      </p>
    </slot>
    <slot name="cta">
      <ButtonLink v-if="!hideButton && (to || href)" :to="to" :href="href">
        {{ buttonLabel ?? t("no_data.button_label") }}
      </ButtonLink>
      <ButtonLink v-else-if="!hideButton && !to && !href" @click="emit('click')">
        {{ buttonLabel ?? t("no_data.button_label") }}
      </ButtonLink>
    </slot>
  </div>
</template>
